import * as Sentry from '@sentry/react';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const appEnv = import.meta.env.MODE || (import.meta.env.PROD ? 'production' : 'development');

export const isSentryEnabled = Boolean(sentryDsn);

export const initSentry = () => {
  if (!sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    environment: appEnv,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 0.1 : 0,
    beforeSend(event) {
      // Keep reporting privacy-conscious: do not attach browser console breadcrumbs
      // or arbitrary local state. Sentry's default event payload still includes
      // stack traces, URL, release/environment, and browser metadata.
      return event;
    },
  });
};

export const captureException = (error: unknown, context?: Record<string, unknown>) => {
  if (!isSentryEnabled) {
    return;
  }

  Sentry.captureException(error, {
    extra: context,
  });
};
